<template>
  <v-layout row>
    <v-flex xs12>
      <p class="form-subtitle">お支払い方法</p>
      <v-radio-group
        row
        required
        v-model="modelPaymentMethod"
        name="payment_method"
        class="paymant-radio"
        :value="paymentMethod"
        :error-messages="errorPaymentMethod"
      >
        <v-radio v-for="(label, value) in paymentOptions" :key="value" :value="value" :label="label"></v-radio>
      </v-radio-group>
      <v-layout row v-show="showDepositAt" mb20>
        <v-flex xs12>
          <label for="" class="datepicker-label">お支払い予定日</label>
          <vuejs-datepicker
            name="deposit_at"
            format="yyyy-MM-dd"
            :language="datepickerJa"
            class="datepicker"
            :default="depositAt"
            :disabled-dates="disabledDates"
          ></vuejs-datepicker>
          <div class="alert" v-if="errorDepositAt">{{ errorDepositAt }}</div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import vuejsDatePicker from 'vuejs-datepicker'
import {ja} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    'vuejs-datepicker': vuejsDatePicker
  },

  props: [
    'paymentMethod',
    'errorPaymentMethod',
    'paymentOptions',
    'depositAt',
    'errorDepositAt',
    'daShowBank',
    'daShowCredit',
  ],

  data () {
    return {
      modelPaymentMethod: this.paymentMethod,
      datepickerJa: ja,
      disabledDates: {
        to: new Date()
      }
    }
  },

  computed: {
    showDepositAt () {
      return this.daShowBank.includes(parseInt(this.modelPaymentMethod))
    },
    showCreditNote () {
      return this.daShowCredit.includes(parseInt(this.modelPaymentMethod))
    }
  },
}
</script>

<style lang="scss" scoped>
  .datepicker {
    border-bottom: 1px solid #555;
    width: 200px;
    font-size: 1.1rem;
    &-label {
      font-size: 1rem;
      color: #555;
    }
  }

  .alert {
    color: #e3342f;
    font-size: 1rem;
  }
</style>

<style>
  .payment-radio .v-messages .theme--light {
    margin-bottom: 20px;
  }
</style>

